document.addEventListener('DOMContentLoaded', async () => {
  // Never override Shopify's native collection catalog grid
  if (document.querySelector('#ProductGridContainer') || document.querySelector('ul#product-grid.grid')) {
    return;
  }

  const pathParts = window.location.pathname.split('/');
  const handle = pathParts[pathParts.indexOf('collections') + 1];
  if (!handle) return;

  try {
    const PER_PAGE = 18;
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(urlParams.get('page') || '1', 10);

    const res = await fetch(`/collections/${handle}/products.json?limit=250`);
    if (!res.ok) return;

    const data = await res.json();
    const products = data.products || [];
    if (!products.length) return;

    const totalPages = Math.ceil(products.length / PER_PAGE);
    const start = (currentPage - 1) * PER_PAGE;
    const pageProducts = products.slice(start, start + PER_PAGE);

    const deliveryDate =
      window.DMProductCards && typeof window.DMProductCards.getUtcDeliveryDate === 'function'
        ? window.DMProductCards.getUtcDeliveryDate()
        : (function () {
            var now = new Date();
            var d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
            return d.toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              timeZone: 'UTC'
            });
          })();

    const createCard = (p) => {
      const v = p.variants && p.variants[0];
      if (!v) return '';

      return `
        <div class="product-card">
          <a href="/products/${p.handle}">
            <div class="product-img-wrapper">
              <img src="${p.images[0]?.src || ''}" alt="${p.title}">
            </div>
          </a>
          <div class="product-title">${p.title}</div>
          <div class="price">$${parseFloat(v.price).toFixed(2)}</div>
          <div class="delivery-line">
            <span class="green-dot"></span>
            FREE delivery ${deliveryDate}
          </div>
          <button type="button" class="add-to-cart dm-add-to-cart-btn" data-variant-id="${v.id}">Add to Cart</button>
        </div>
      `;
    };

    const buildPagination = () => {
      if (totalPages <= 1) return '';
      let links = '';
      for (let i = 1; i <= totalPages; i++) {
        const active = i === currentPage ? 'style="font-weight:bold;text-decoration:underline;"' : '';
        links += `<a href="?page=${i}" ${active} class="page-link">${i}</a>`;
      }
      return `<div class="collection-pagination">${links}</div>`;
    };

    const grid = document.querySelector('.brand-products .product-grid, .brand-viewer .product-grid');
    if (!grid) return;

    grid.innerHTML = pageProducts.map(createCard).join('') + buildPagination();
  } catch (error) {
    console.warn('District Mailing collection-cards.js skipped:', error);
  }
});
